import store from '@/store'
import { ref, computed } from '@vue/composition-api'
import { socialAuthRedirect, socialBind, socialUnBind, socialLogin } from '@/api/login.js'
import { Message } from 'element-ui'
import website from '@/config/website.js'
import { urlParams } from '@/util/util.js'
import { useRouter } from '@/hooks'
import mqStore from '@/util/mqtt-engine'

const { createConnect } = mqStore()
const router = useRouter()

/**
 *
 * @param {*} paramObj
 * refreshRoute 绑定成功后，需要刷新的页面路由
 * socialType 三方类型
 * socialCallback 三方授权登录回调
 * @returns
 */
export const useAuthLogin = (paramObj) => {
  const { refreshRoute, socialType, socialCallback } = paramObj || {}

  const authLoginLoading = ref(false)
  // 登录参数
  const loginParams = ref({
    type: socialType || 10, // 微信开放平台：10
    clientId: website.auth.client_id
  })
  // 登录后跳转路由
  const tagWel = computed(() => {
    return store.state.tags.tagWel
  })

  /**
   * 获取微信授权页面地址
   * @returns
   */
  const getWxAuthUrl = async () => {
    const redirectUri =
      process.env.NODE_ENV === 'production'
        ? window.location.href
        : 'https://custom.ayundi.cn/login?redirect=index'
    const param = {
      type: 10,
      redirectUri
    }
    authLoginLoading.value = true
    const res = await socialAuthRedirect(param)
    authLoginLoading.value = false
    const { code, data } = res || {}
    if (code !== 0) {
      return
    }
    // 跳转微信页面授权
    const openType = process.env.NODE_ENV === 'production' ? '_self' : '_blank'
    window.open(data, openType)
  }

  /**
   * 授权成功后，从授权页面返回，进行登录
   * @returns
   */
  const wxAuthLogin = async () => {
    const params = urlParams()
    const { code, state } = params || {}
    if (!code || !state) {
      return
    }
    try {
      authLoginLoading.value = true
      loginParams.value.code = code
      loginParams.value.state = state
      const res = await socialLogin(loginParams.value)
      const { code: code2, data } = res || {}
      if (code2 !== 0) {
        return
      }
      const { status, msg, token } = data || {}
      // status 0 已绑定  1未绑定   2超时
      if (status === 2) {
        Message.error('微信登录已过期，请刷新页面')
        router.replace({ path: '/login' })
        return
      }
      // openId与账号未绑定
      if (status === 1) {
        Message.error(msg)
        socialCallback && socialCallback('wx')
        return
      }
      // openId与账号已绑定
      if (status === 0) {
        // 设置token信息
        store.dispatch('SetLoginToken', token)
        // 获取用户信息
        const res2 = await store.dispatch('GetUserInfo')
        const { code: code3 } = res2 || {}
        if (code3 !== 0) {
          return
        }
        console.log('tagWel:', tagWel.value.value)
        router.push({ path: tagWel.value.value })

        // 订阅登录登出消息
        createConnect()
        store.dispatch('subScribeLogout', () => {
          router.push({ path: '/login' })
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      authLoginLoading.value = false
    }
  }

  /**
   * 授权成功后，从授权页面返回，在url中获取code,state参数,进行openId和账号绑定
   * @returns
   */
  const handleBind = async () => {
    const params = urlParams()
    const { code, state } = params || {}
    if (!code || !state) {
      return
    }
    loginParams.value.code = code
    loginParams.value.state = state
    try {
      authLoginLoading.value = true
      const res = await socialBind(loginParams.value)
      const { code: code2 } = res || {}
      if (code2 !== 0) {
        return
      }
      refreshRoute && Message.success('绑定成功')
      // 刷新授权信息
      store.dispatch('GetUserInfo')
      // 重新进入此页面，去掉页面url的参数
      refreshRoute && router.replace({ path: refreshRoute })
    } catch (error) {
      console.log(error)
    } finally {
      authLoginLoading.value = false
    }
  }

  /**
   * 解除openId和账号的绑定
   * @returns
   */
  const handleUnBind = async () => {
    try {
      const param = {
        socialType: socialType || 10
      }
      authLoginLoading.value = true
      const res = await socialUnBind(param)
      const { code: code2 } = res || {}
      if (code2 !== 0) {
        return
      }
      Message.success('微信授权登录关闭')
      // 刷新授权信息
      store.dispatch('GetUserInfo')
    } catch (error) {
      console.log(error)
    } finally {
      authLoginLoading.value = false
    }
  }

  return {
    authLoginLoading,
    getWxAuthUrl,
    wxAuthLogin,
    handleBind,
    handleUnBind
  }
}
